import { gql } from "@apollo/client";

export const FACTURAR_SAP = gql`
mutation facturarSAP($mes: Int!, $anio: Int!, $fechaDesde: CustomDateTime!, $fechaHasta: CustomDateTime!) {
    facturarSAP(mes: $mes, anio: $anio, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta) {
        success
        valorEsperado
        error
    }
}`;